import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListReproductions from './ListReproductions.js';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import Upload from '../../shared/Upload.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';

import TagNumberInput from '../../shared/inputs/TagNumberInput.js';
import LotDropdown, { parseLotValue } from '../lots/LotDropdown.js';

export const ReproductionV2 = ({ initialLotFilter, screen, setScreen, actions }) => {
  const { t } = useTranslation();
  const [localScreen, setLocalScreen] = useState("list");
  const [editRow, setEditRow] = useState({});

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  const getBodyFromForm = (formData, row) => {
    console.log("reproduction row add", row);
    const tag = formData.get("tag");

    // Parse lot value to get lot_id, protocol_id, protocol_name, start_date, bull_id, bull_name
    const lotValue = formData.get("lot");
    const lotData = parseLotValue(lotValue);
    if (!lotData) {
      console.error("Invalid lot selection");
      return null;
    }

    const { lot_id, protocol_id, protocol_name, start_date, bull_id, bull_name } = lotData;

    const result = "in_progress";

    const notes = [];
    // Mark day 0 as completed when animal is added
    const protocol = {
        "timeline_days":[
          {"treatments":[{"completed":false},{"completed":false}],"completed":true},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
          {"treatments":[{"completed":false},{"completed":false}],"completed":false},
        ]
      };

    return JSON.stringify({
      tag, lot_id, protocol_id, protocol_name,
      start_date, bull_id, bull_name, result, notes, protocol,
    });
  }

  const ReproductionForm = (props) => {
    const [tag, setTag] = useState(props.tag);
    const [selectedLot, setSelectedLot] = useState("");
    return (
      <>

        <TagNumberInput
          value={tag}
          edit={true}
          onChange={(e) => setTag(e.target.value)}
        />

        <LotDropdown
          selected={selectedLot}
          onChange={(e) => setSelectedLot(e.target.value)}
          encodeValue={true}
        />
      </>
    );
  }

  const selection = (rows) => {
    console.log("selection made", rows);
    if (rows.length === 1) {
      setEditRow(rows[0]);
    } else {
      setEditRow(null);
    }
  }

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === "list" && (
        <>
          <ListReproductions
            onSelection={selection}
            initialLotFilter={initialLotFilter}
          />
          <FAB onClick={() => setCurrentScreen("add")} />
        </>
      )}
      {currentScreen === "upload" && (
        <Upload collection="lots.animals"
          onSuccess={() => setCurrentScreen("list")}
        />
      )}
      {currentScreen === "add" && (
        <DataCollectionAdd
          collection="lots.animals"
          getBodyFromForm={getBodyFromForm}
          formElements={ReproductionForm}
          onSuccess={() => setCurrentScreen("list")}
          successMsg={t("animal_added_success")}
          duplicateMsg={t("reproduction_duplicate_msg")}
        />
      )}
    </>
  );
}

// Action buttons component for use in hub header
export const ReproductionV2Actions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
    <UploadButton
      isActive={screen === "upload"}
      onClick={() => setScreen("upload")}
    />
    <DownloadButton collection="lots.animals"/>
  </div>
);

export default ReproductionV2;
